import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { orgUnitsStoreStateSelector } from '~/selectors';

export const useMyUnitIds = (): {
  aMyDeputyUnits: number[];
  aMyAltUnits: number[];
  aMyManUnits: number[];
  aMyHRUnits: number[];
  allMyResponsibleUnits: number[];
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
} => {
  const storeData = useSelector((state: StoreState) => {
    return orgUnitsStoreStateSelector(state);
  });

  const { aMyHRUnits, aMyManUnits, aMyAltUnits, aMyDeputyUnits } = storeData;

  const allMyResponsibleUnits = useMemo(() => {
    return aMyHRUnits
      .concat(aMyManUnits)
      .concat(aMyAltUnits)
      .concat(aMyDeputyUnits);
  }, [aMyHRUnits, aMyManUnits, aMyAltUnits, aMyDeputyUnits]);

  return {
    ...storeData,
    allMyResponsibleUnits,
  };
};
